import { useState, useEffect } from 'react';

export const useIsVisible = (root: Element, el: Element): boolean => {
    const [isIntersecting, setIsIntersecting] = useState(true);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsIntersecting(entry.isIntersecting);
            },
            {
                root,
                threshold: 1.0,
            },
        );

        if (el) {
            observer.observe(el);
        }

        return () => {
            observer.disconnect();
        };
    }, [el]);

    return isIntersecting;
};
